<template>
  <div class="sidebar" :class="{ collapsed }">
    <div>
      <div class="siderbar__logo" v-if="collapsed">A</div>
      <div class="siderbar__logo" v-else>Adbox</div>
    </div>
    <nav v-if="role">
      <ul class="sidebar__navbar__list">
        <li class="sidebar__navbar__item">
          <router-link to="/">
            <Icon name="Home" class="sidebar__navbar__item__icon" />
            <p>Home</p>
          </router-link>
        </li>
        <li class="sidebar__navbar__item" v-if="role.name === 'super'">
          <router-link to="/collections">
            <Icon name="Collection" class="sidebar__navbar__item__icon" />
            <p>Collections</p>
          </router-link>
        </li>
        <li class="sidebar__navbar__item">
          <router-link to="/advertisements">
            <Icon name="ViewGridAdd" class="sidebar__navbar__item__icon" />
            <p>Advertisements</p>
          </router-link>
          <ul class="w-full">
            <li>
              <router-link to="/advertisements">
                <p class="text-white">Visible</p>
              </router-link>
            </li>
            <li>
              <router-link to="/advertisements/invisible">
                <p class="text-white">No Visible</p>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sidebar__navbar__item" v-if="role.name === 'super'">
          <router-link to="/tiktoks">
            <Icon name="Tiktok" class="sidebar__navbar__item__icon" />
            <p>TikToks</p>
          </router-link>
        </li>
        <li class="sidebar__navbar__item" v-if="role.name === 'super'">
          <router-link to="/ugc-creators">
            <Icon name="UserGroup" class="sidebar__navbar__item__icon" />
            <p>UGC Creators</p>
          </router-link>
        </li>
        <li class="sidebar__navbar__item" v-if="role.name === 'super'">
          <router-link to="/customers">
            <Icon name="UserGroup" class="sidebar__navbar__item__icon" />
            <p>Customers</p>
          </router-link>
        </li>
        <li class="sidebar__navbar__item" v-if="role.name === 'super'">
          <router-link to="/pricing">
            <Icon name="CurrencyUsd" class="sidebar__navbar__item__icon" />
            <p>Pricing</p>
          </router-link>
        </li>
        <li class="sidebar__navbar__item" v-if="role.name === 'super'">
          <router-link to="/titles-subtitles">
            <Icon name="UserGroup" class="sidebar__navbar__item__icon" />
            <p>Titles & Substitles</p>
          </router-link>
        </li>

        <li class="sidebar__navbar__item">
          <a @click="signOut">
            <Icon name="Logout" class="sidebar__navbar__item__icon" />
            <p>Sign Out</p>
          </a>
        </li>
      </ul>
    </nav>
    <div class="sidebar__btn_collapse h-16" @click="collapse">
      <Icon
        name="ArrowNarrowRight"
        class="sidebar__btn_collapse__icon"
        v-if="collapsed"
      />
      <Icon name="ArrowNarrowLeft" class="sidebar__btn_collapse__icon" v-else />
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon },
  setup() {
    const store = useStore();

    const collapsed = ref(false);

    const role = computed(() =>
      store.state.currentUser ? store.state.currentUser.role : null
    );

    const signOut = () => {
      store.dispatch("SIGN_OUT");
    };

    const collapse = () => {
      collapsed.value = !collapsed.value;
    };

    return { collapsed, role, signOut, collapse };
  },
};
</script>

<style>
.sidebar {
  max-width: 600px;
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
  background-color: #001529;
}
.sidebar.collapsed {
  max-width: 60px;
}
.siderbar__logo {
  @apply grid place-content-center;
  color: #fff;
  font-weight: 900;
  font-size: 32px;
  padding: 16px;
}
.sidebar__navbar__list {
  list-style: none;
}
.sidebar__navbar__item a {
  display: flex;
  align-items: center;
  color: #fff;
  text-align: left;
  padding: 15px 0;
}
.sidebar__navbar__item ul a {
  @apply pl-16;
}
.sidebar__navbar__item a:hover {
  background-color: #002140;
}
.sidebar__navbar__item__icon {
  width: 22px;
  margin-left: 20px;
  margin-right: 10px;
  stroke: #fff;
}
.sidebar__navbar__item a p {
  color: #fff;
}
.sidebar__btn_collapse {
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #002140;
  cursor: pointer;
}
.sidebar.collapsed .sidebar__btn_collapse {
  width: 60px;
}
.sidebar.collapsed .sidebar__navbar__item a p {
  display: none;
}
.sidebar__btn_collapse__icon {
  width: 32px;
  stroke: #fff;
}
</style>
